export default __webpack_public_path__ + "static/media/grey-check.8b3c100e.png";